<template>
    <b-card class="px-1 mt-1 mb-2" style="cursor: pointer" @click="gotoDetails">
        <!-- Card Header -->

        <b-row class="text-center">
            <b-col>
                <b-alert
                    variant="warning"
                    show
                    class="font-weight-bold py-1"
                    style="font-size: 0.6em"
                >
                    {{ orderTypeName.toUpperCase() }}
                    <b-badge v-if="!!order.completed" variant="secondary">{{
                        orderStatus(order.completed)
                    }}</b-badge>
                    <b-badge
                        v-else-if="overdue(order.schedule_at)"
                        variant="danger"
                        >{{ orderStatus(order.completed) }}</b-badge
                    >

                    <b-badge v-else variant="success">{{
                        orderStatus(order.completed)
                    }}</b-badge>
                </b-alert>
            </b-col>
            <!--b-col>
                <b-button
                    variant="outline-primary"
                    :to="`/customer-portal/view-service/${order.id}`"
                >
                    View
                </b-button>
            </b-col-->
        </b-row>

        <b-row class="mb-2">
            <b-col>
                <small class="font-weight-bold text-muted">
                    Reference Number
                </small>
                <h5>{{ order.reference_no }}</h5>
            </b-col>
            <b-col>
                <small class="font-weight-bold text-muted"> Category </small>
                <h5>
                    <span class="danger">
                        {{
                            (order.category && order.category.name) || '-'
                        }}</span
                    >
                </h5>
            </b-col>
        </b-row>

        <b-row class="mb-2">
            <b-col>
                <small class="font-weight-bold text-muted"> Date Due </small>
                <h5>{{ order.schedule_at | filterDate }}</h5>
            </b-col>
            <b-col v-if="!!order.completed_at">
                <small class="font-weight-bold text-muted">
                    Date Completed
                </small>
                <h5>{{ order.completed_at | filterDate }}</h5>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <small class="font-weight-bold text-muted"> Description </small>
                <h5>
                    {{ (order.description || '').slice(0, 25) }}
                </h5>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col>
                <small class="font-weight-bold text-muted"> Price </small>
                <h5>{{ order.items | filterPrice }}</h5>
            </b-col>
            <b-col>
                <small class="font-weight-bold text-muted">
                    Officer Assigned
                </small>
                <h5>{{ order.driver | filterOfficerName }}</h5>
            </b-col>
        </b-row>
    </b-card>
</template>
<style scoped>
h5 {
    font-size: 1em;
}

small {
    font-size: 0.7em;
}

h6 {
    font-size: 1em;
}
</style>
<script>
export default {
    name: 'Issue',

    props: ['order'],

    filters: {
        filterDate(date) {
            return date.split(' ')[0]
        },
        filterOfficerName(officer) {
            if (!officer) return ''
            return officer.first_name + ' ' + officer.last_name
        },
        filterPrice(items) {
            const formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            })
            const sum = items.reduce((sum, item) => {
                sum +=
                    parseFloat(item.quantity) *
                    parseFloat(item.price) *
                    (1 + parseFloat(item.tax_rate) / 100)
                return sum
            }, 0)
            if (!sum) return '-'

            return formatter.format(sum) /* $2,500.00 */
        },
    },
    computed: {
        orderTypeName() {
            return (
                this.order &&
                this.order.type &&
                (this.order.type.customer_portal_name || this.order.type.name)
            )
        },
    },

    methods: {
        gotoDetails() {
            this.$router.push(`/customer-portal/view-service/${this.order.id}`)
        },
        filterSection(section) {
            if (!section) return ''
            const { name, location } = section || {}
            const { address1, address2, city } = location || {}
            return `${name}<br/>${address1}<br/>${address2}<br/>${city}`
        },
        overdue(scheduledDelivery) {
            /* Returns true if overdue, returns false if on time */
            var schedule = new Date(Date.parse(scheduledDelivery))

            const schYear = schedule.getFullYear()
            const schMonth = schedule.getMonth()
            const schDay = schedule.getDate()
            const now = new Date()
            const currentYear = now.getFullYear()
            const currentMonth = now.getMonth()
            const currentDay = now.getDate()
            if (currentYear <= schYear) {
                if (currentMonth <= schMonth) {
                    if (currentDay <= schDay) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return true
                }
            } else {
                return true
            }
        },
        orderStatus(status) {
            return status == 1 ? 'Complete' : 'Open'
        },
    },
}
</script>
